import { listFiles as apiListFiles, uploadFiles as apiUploadFiles, deleteFile as apiDeleteFile } from './fileApi';

export const getBlobsInContainer = async (prefix = '') => {
  try {
    const files = await apiListFiles(prefix);  
    return files
  } catch (error) {
    console.error('Error getting blobs in container:', error);
    return [];
  }
};

export const createBlobInContainer = async (file, prefix = '') => {
  console.log("file", file);
  const urls = await apiUploadFiles([file], prefix);
  return urls[0];
};
export const deleteBlobIfItExists = async (blobName) => {
  await apiDeleteFile(blobName);
  console.log(`deleted blob ${blobName}`);
};
